import * as React from 'react'
import Seo from './Seo.js'

import CSSReset from '../styles/CSSReset'
import OpenProps from '../styles/OpenProps'
import GlobalStyles from '../styles/GlobalStyles'

import Header from './Header'
import Main from './Main'
import Footer from './Footer'

export default function Layout({
  children,
  title = false,
  description = false,
  image = false,
  path = false,
  modifier = false,
}) {
  return (
    <>
      <CSSReset />
      <OpenProps />
      <GlobalStyles />
      <Seo title={title} description={description} image={image} path={path} />
      <Header />
      <Main modifier={modifier}>{children}</Main>
      <Footer />
    </>
  )
}
